import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import FooterCopyright from "../../components/footer/FooterCopyright";

const socialLinks = [
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/tcxela001/?locale=es_LA",
    Icon: FaFacebookF,
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/telefoniacastro/",
    Icon: FaInstagram,
  },
];

const FooterThree = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
}) => {
  return (
    <footer
      className={clsx(
        "footer-area bg-footer",
        backgroundColorClass,
        spaceTopClass,
        spaceBottomClass
      )}
    >
      <div className="container">
        <div className="footer-border tc-footer-content text-theme-color">
          <div className="row md:flex-reverse justify-content-center text-center">
            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <FooterCopyright
                footerLogo="/assets/img_tc/brand/tc-logo-negative.png"
                spaceBottomClass="mb-0"
                colorClass="text-theme-color-dark"
              />
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <div className="footer-widget tc-footer-widget-centered">
                <div className="footer-title">
                  <h3>Nosotros</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <Link to="/nosotros">Acerca de Nosotros</Link>
                    </li>
                    <li>
                      <Link to="/tiendas_tc">Tiendas</Link>
                    </li>
                    <li>
                      <Link to="/contacto">Contacto</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <div className="footer-widget tc-footer-widget-centered">
                <div className="footer-title">
                  <h3>Políticas</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <Link to="/devoluciones">Devoluciones</Link>
                    </li>
                    <li>
                      <Link to="/terminos-y-condiciones">Términos y Condiciones</Link>
                    </li>
                    <li>
                      <Link to="/politica-de-privacidad">Política de Privacidad</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <div className="footer-widget tc-footer-widget-centered">
                <div className="footer-title">
                  <h3>Síguenos en</h3>
                </div>
                <div className="footer-list d-flex justify-content-center">
                  <ul className="tc-footer-social-list list-unstyled p-0 m-0">
                    {socialLinks.map(({ id, label, href, Icon }) => (
                      <li key={id}>
                        <a
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          className="tc-footer-social-link"
                        >
                          <span className="tc-footer-social-icon">
                            <Icon aria-hidden="true" />
                          </span>
                          <span>{label}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

FooterThree.propTypes = {
  backgroundColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default FooterThree;
